import store from '@/store'
const Dashboard = () => import('@/views/user/Dashboard.vue')
const Profile = () => import('@/views/user/Profile.vue')
const SearchFiles = () => import('@/views/archives/SearchFiles.vue')
const SearchResult = () => import('@/views/archives/SearchResult.vue')
const PdfPreviewer = () => import('@/views/archives/PdfViewer.vue')
const Bookmarks = () => import("@/views/user/Bookmark.vue")
const Notification = () => import('@/views/user/Notification.vue')

//user secondary components
const Settings = () => import('@/views/user/Settings.vue')
const About = () => import('@/views/user/AboutEdwork.vue')
const HelpAndFeedBack = () => import('@/views/user/HelpAndFeedBack.vue')
const User = () => import('@/views//user/User.vue')



export default {
    path: '/u',
    component: User,
    children: [
        //make the default route dashboard
        {
            path: 'home',
            component: Dashboard,
            name: "dashboard",

        },
        {
            path: 'about',
            component: About,
            name: "about"
        },

        {
            path: 'feedbacks',
            component: HelpAndFeedBack,
            name: "feedback",

        },
        {
            path: 'profile',
            component: Profile,
            name: "profile"
        },

        {
            path: 'archives/search',
            component: SearchFiles,
            name: "search",
        },

        {
            path: 'archives/search/:query',
            component: SearchResult,
            name: "search-result",
        },
        //preview
        {
            path: "results/:id",
            name: "pdf-viewer",
            component: PdfPreviewer,
        },
        {
            path: 'settings',
            component: Settings,
            name: "settings"
        },
    
        {
            path: 'bookmarks',
            component: Bookmarks,
            name: "bookmarks",

        },
        {
            path: "notification",
            name: "notification",
            component: Notification,
        }

    ],
    //return the user to login page if they are not authenticated
     beforeEnter: (from, to, next) => {
        if (!store.getters["auth/authenticated"]) {
            return next({
                name: "login"
            })
        }
        next()
    } 
}



